import { AUTH_ME } from '@/graphql/query.graphql';
import { authMeQuery, useSetTourGuideEnabledMutation } from '@/types/generated/graphql';
import { ApolloCache } from '@apollo/client';

export function useDisableTourGuide() {
  const [setTourGuideEnabledMutation] = useSetTourGuideEnabledMutation();

  const disableTourGuide = () =>
    setTourGuideEnabledMutation({
      variables: { tourGuideEnabled: false },
      update: (cache) => cacheUpdateTourGuideEnabled(cache),
    });

  return { disableTourGuide };
}

function cacheUpdateTourGuideEnabled(cache: ApolloCache<unknown>) {
  const authMe = cache.readQuery<authMeQuery>({ query: AUTH_ME });
  const user = authMe?.authMe?.data?.user;
  if (!user) return;
  cache.modify({
    id: cache.identify(user),
    fields: { tourGuideEnabled: () => false },
  });
}
